import { loginUsersAccountsPath } from "src/routes";

type LoginResult = SuccessfulLoginResponse | UnsuccessfulLoginResponse
type SuccessfulLoginResponse = Record<PropertyKey, never>;
type UnsuccessfulLoginResponse = { errors: string[]; };

const login = async (formData: FormData): Promise<LoginResult> => {
  const requestPath = loginUsersAccountsPath();
  const result = await fetch(requestPath, {
    method: "POST",
    credentials: "include",
    body: JSON.stringify(Object.fromEntries(formData)),
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
  });

  if (result.status < 300) {
    return {};
  } else {
    return await result.json() as LoginResult;
  }
}

export { login, LoginResult }
